module.exports = __webpack_public_path__ + "static/C-indice-infeccao-c265e0f9f7e33b2e310eaf43b412af1f.png";